import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { FaqTopic } from '../models';

import RightCaretIcon from './icons/RightCaretIcon';
import BoldRightCaretIcon from './icons/RightCaretBoldIcon';
import { PartnerThemeProps } from 'packages/smart-home-support/themes';

const SelectableItem = styled.div<{ selected: boolean }>`
  width: 100%;
  padding: 20px;
  border-radius: 6px;
  color: #1b1b1b;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: pointer;

  ${(props) =>
    props.selected
      ? `color: ${props.theme.colors.faqAccent}; font-weight: bold; background-color: ${
          props.theme.colors.featureSection1
        };`
      : ''}
`;

const SelectableItemText = styled.span`
  padding-right: 15px;

  font-style: normal;
  font-size: 18px;
  text-transform: uppercase;
`;

const SelectableItemIcon = styled.span`
  height: 15px;
  flex-shrink: 0;
  display: flex;
`;

const FaqTopicItem: React.SFC<{ selectedFaqTopic; setSelectedFaqTopic } & FaqTopic & PartnerThemeProps> = (props) => {
  const selected: boolean = props.id === props.selectedFaqTopic;
  return (
    <SelectableItem selected={selected} onClick={() => props.setSelectedFaqTopic(props.id)}>
      <SelectableItemText>{props.title}</SelectableItemText>
      <SelectableItemIcon>
        {selected ? <BoldRightCaretIcon color={props.theme.colors.primaryAccent} /> : <RightCaretIcon />}
      </SelectableItemIcon>
    </SelectableItem>
  );
};

export default withTheme(FaqTopicItem);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/FaqTopicItem.tsx